import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import css from '../../css/group/roomList.module.scss';
import { selectChatGroup, selectGroup } from '../../slice/chatGroupSlice';
import { Room } from './room';

export const RoomList: React.FC = () => {
    const { selectedChatGroup: group, groups, friendGroups } = useSelector(selectChatGroup);

    const dispatch = useDispatch();
    const params = useParams<{ groupId: string }>();
    const groupId = Number(params.groupId);
    useEffect(() => {
        if (groupId) {
            dispatch(selectGroup(groupId));
        } else {
            const allGroups = [...groups, ...friendGroups];
            if (allGroups.length !== 0) {
                dispatch(selectGroup(allGroups[0].id));
            }
        }
    }, [groups, friendGroups, groupId, dispatch]);
    return (
        <div className={css.wrapper}>
            <div className={css.title}>{group?.chatRooms.length}ボイチャルーム</div>

            <div className={css.rooms}>
                <ul>
                    {group?.chatRooms.map((room, idx) => {
                        return (
                            <li key={idx}>
                                <Room group={group} room={room} />
                            </li>
                        );
                    })}
                </ul>
            </div>
        </div>
    );
};
